// Email notifications via the Static Web App managed API.
//
// The /api/notify Function sends email server-side using Microsoft Graph.
// The Graph client secret never reaches the browser. The Okta ID token is
// forwarded with the request for server-side caller validation.

import { getAuthToken } from './api';

const sendNotification = async ({ template, ...args }) => {
  try {
    const headers = { 'Content-Type': 'application/json' };
    const token = getAuthToken();
    // X-Auth-Token, not Authorization: SWA's proxy replaces Authorization
    // with an internal Functions-runtime token before /api/* code runs,
    // so a custom header is the only way to deliver the Okta JWT intact.
    if (token) headers['X-Auth-Token'] = token;

    const res = await fetch('/api/notify', {
      method: 'POST',
      headers,
      body: JSON.stringify({ template, ...args }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      console.error('Notification API error:', err);
    }
  } catch (err) {
    console.error('Email notification failed:', err);
    // Non-blocking — review submission succeeds even if email fails
  }
};

export const notifyManagerReviewReady = async ({ managerEmail, employeeName, cycleLabel }) => {
  await sendNotification({
    template: 'managerReviewReady',
    managerEmail,
    employeeName,
    cycleLabel,
  });
};

export const notifyEmployeeFeedbackReady = async ({ employeeEmail, managerName, cycleLabel }) => {
  await sendNotification({
    template: 'employeeFeedbackReady',
    employeeEmail,
    managerName,
    cycleLabel,
  });
};
